import { tasksRead, taskAdd, taskUpdate, taskDelete } from "../api";
import {
  dataFailure,
  dataSuccess,
} from "./general";

export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const SET_SELECTED_TASK = "SET_SELECTED_TASK";

const fetchTasksSuccess = (values) => {
  return {
    type: FETCH_TASKS_SUCCESS,
    payload: values,
  };
}

export const fetchTasks = (values) => {
  return async (dispatch) => {
    try {
      const returnJSONData = await dispatch(tasksRead(values))
      await dispatch(fetchTasksSuccess(returnJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const addTaskData = (values) => {
  return {
    type: ADD_TASK,
    payload: values
  }
}

export const addTask = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(taskAdd(values));
      await dispatch(addTaskData(JSONData));
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const updateTaskData = (values) => {
  return {
    type: UPDATE_TASK,
    payload: values
  }
}

export const updateTask = (values) => {
  return async (dispatch) => {
    
    try {
      const JSONData = await dispatch(taskUpdate(values));
      await dispatch(updateTaskData(JSONData));
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const deleteTaskData = (values) => {
  return {
    type: DELETE_TASK,
    payload: values
  }
}

export const deleteTask = (values) => {
  return async (dispatch) => {
    
    try {
      await dispatch(deleteTaskData(values));
      await dispatch(taskDelete(values))
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

export const setSelectedTask = (values) => {
  return {
    type: SET_SELECTED_TASK,
    payload: values
  }
}